import * as THREE from "three";
import vertexShader from "../../shaders/visualizer/vertex.glsl";
import fragmentShader from "../../shaders/visualizer/fragment.glsl";

import sphereVertex from "../../shaders/visualizer/sphereVertex.glsl";
import sphereFragment from "../../shaders/visualizer/sphereFragment.glsl";

export class Visualizer {
  constructor(scene, camera) {
    this.scene = scene;
    this.camera = camera;
    this.textureLoader = new THREE.TextureLoader();

    this.createAnalyser();
  }

  createMesh() {
    if (this.group) {
      this.group.traverse((child) => {
        if (child.isMesh) {
          child.geometry.dispose();
          if (child.material.isMaterial) child.material.dispose();
        }
      });
      this.scene.remove(this.group);
    }
    const geometry = new THREE.PlaneGeometry(5, 5);
    const material = new THREE.ShaderMaterial({
      vertexShader,
      fragmentShader,
      uniforms: {
        uTime: { value: 0 },
        uTexture: { value: null },
        uAudioLevel: { value: 0 },
      },
    });
    const sphereGeometry = new THREE.SphereGeometry(20, 25);
    const materialSphere = new THREE.ShaderMaterial({
      vertexShader: sphereVertex,
      fragmentShader: fragmentShader,
      wireframe: true,
      uniforms: {
        uTime: { value: 0 },
        uAudioLevel: { value: 0 },
      },
    });
    this.mesh = new THREE.Mesh(geometry, material);
    this.sphere = new THREE.Mesh(sphereGeometry, materialSphere);

    this.group = new THREE.Group();

    this.sphere.position.z = -3;
    this.group.add(this.mesh);
    this.group.add(this.sphere);
    this.scene.add(this.group);
  }

  createAnalyser() {
    if (!this.audioContext) {
      this.audioContext = new (
        window.AudioContext || window.webkitAudioContext
      )();
      this.analyser = this.audioContext.createAnalyser();
      this.analyser.fftSize = 2048;
      this.analyser.smoothingTimeConstant = 0.8;
      this.bufferLength = this.analyser.frequencyBinCount;
      this.dataArray = new Uint8Array(this.bufferLength);
    }

    if (this.audio) {
      this.audio.pause();
      this.audio.src = "";
    }

    this.audio = new Audio();
    this.audio.crossOrigin = "anonymous";
    this.audio.loop = true;

    this.source = this.audioContext.createMediaElementSource(this.audio);
    this.source.connect(this.analyser);
    this.analyser.connect(this.audioContext.destination);
  }
  async playTrack(track) {
    if (!this.audioContext) this.createAnalyser();

    if (this.audioContext.state === "suspended") {
      await this.audioContext.resume();
    }

    this.audio.src = track.file;
    this.audio.volume = 0.5;

    try {
      console.log(this.audioContext.state);
      await this.audio.play();
    } catch (e) {
      console.log("audio play failed:", e);
    }
  }

  animate() {
    if (this.group) {
      this.mesh.material.uniforms.uTime.value += 0.01;
      this.sphere.material.uniforms.uTime.value += 0.01;
    }

    if (this.analyser && this.dataArray) {
      this.analyser.getByteFrequencyData(this.dataArray);

      let sum = 0;
      for (let i = 0; i < this.bufferLength; i++) sum += this.dataArray[i];
      const avg = sum / this.bufferLength;
      const audioLevel = avg / 255;

      if (this.mesh) {
        this.mesh.material.uniforms.uAudioLevel.value =
          this.sphere.material.uniforms.uAudioLevel.value =
            Math.pow(audioLevel, 1.5) * 2.0;
      }
    }
  }

  onTrackSelected(track) {
    const url = track.cover;
    this.textureLoader.crossOrigin = "";
    this.textureLoader.load(url, (texture) => {
      this.mesh.material.uniforms.uTexture.value = texture;
      this.mesh.material.needsUpdate = true;
    });
    this.playTrack(track);
  }
}
